import { useState, useRef, useEffect } from "react";
import { motion } from "framer-motion";
import ReCAPTCHA from "react-google-recaptcha";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import  {fileTypeVaidation}  from "../Payment/fileTypeValidation";
import apiendspoint from "../../apiendpoint.json";

const links = ["/mail.txt"];

const CareerEnquiryForm = () => {
  const [texts, setTexts] = useState("");
  const [mailbody, setMailBody] = useState("");
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [location, setLocation] = useState("");
  const [department, setDepartment] = useState("");
  const [resume, setResume] = useState(null);
  const [resumename, setResumeName] = useState("");
  const [coverletter, setCoverletter] = useState(null);
  const [coverlettername, setCoverletterName] = useState("");
  const [body, setBody] = useState("");
  const [isCaptchaValid, setIsCaptchaValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const recaptchaRef = useRef();
  const subject = "NextEra Research - Career Enquiry";

  useEffect(() => {
    async function main() {
      const files = await Promise.all(
        links.map((link) => fetch(link).then((res) => res.text()))
      );
      setTexts(files);
    }
    main();
  }, [setTexts]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !location || !email || !department || !resume || !body) {
      toast.error("Please complete the form!!");
      return;
    }

    if (!isCaptchaValid) {
      toast.error("Please complete the reCAPTCHA");
      return;
    }
    setIsLoading(true);

    const newText = texts
      .toString()
      .replace("@name", name)
      .replace("@name", name)
      .replace("@email", email)
      .replace("@location", location)
      .replace("@department", department)
      .replace("@message", body);
    setMailBody(newText);
    const formData = new FormData();
    formData.append("ToEmail", email);
    formData.append("Subject", subject);
    formData.append("Body", newText);
    if (resume) formData.append("Attachments", resume);
    if (coverletter) formData.append("Attachments", coverletter);

    try {
      const response = await fetch(`${apiendspoint.equityUrl}/NextMail/SendNext`, {
        method: "POST",
        body: formData,
      });
      if (!response.ok) {
        throw new Error("Failed to send data");
      }
      toast.success("Mail sent successfully");
      setName("");
      setEmail("");
      setLocation("");
      setDepartment("");
      setResume(null);
      setResumeName("");
      setCoverletter(null);
      setCoverletterName("");
      setBody("");
      setTexts("");
      recaptchaRef.current.reset();
      setIsCaptchaValid(false);
    } catch (error) {
      toast.error("Failed to send mail");
    } finally {
      setIsLoading(false);
    }
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        when: "beforeChildren"
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.5
      }
    }
  };

  return (
    <div className="bg-gradient-to-b from-[#f0f7f3] to-white px-4 py-12 sm:px-6 sm:py-16 lg:px-8 lg:py-20">
      <div className="max-w-7xl mx-auto">
        <motion.div
          className="grid grid-cols-1 lg:grid-cols-2 gap-12"
          initial="hidden"
          animate="visible"
          variants={containerVariants}
        >
          {/* Left Column - Text Content */}
          <motion.div
            className="space-y-8"
            variants={itemVariants}
          >
            <motion.h1
              className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 font-serif"
              variants={itemVariants}
            >
              Join Us and <span className="text-[#0e4322]">Shape the Future</span> Together
            </motion.h1>

            <motion.div>
              <img src="job1.png" alt="" />
            </motion.div>

            <motion.p
              className="text-lg text-gray-700 leading-relaxed"
              variants={itemVariants}
            >
              We believe in providing an ideal environment for those who are passionate about self and organizational growth through meaningful contributions to society.
            </motion.p>

            <motion.div
              className="space-y-6"
              variants={itemVariants}
            >
              <div className="p-6 bg-white rounded-lg shadow-sm border border-gray-100">
                <h3 className="text-xl font-semibold text-[#0e4322] mb-3">Why Join Us?</h3>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start">
                    <svg className="h-5 w-5 text-[#0e4322] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Competitive compensation and benefits</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="h-5 w-5 text-[#0e4322] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Opportunities for professional growth</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="h-5 w-5 text-[#0e4322] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Collaborative and innovative work environment</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="h-5 w-5 text-[#0e4322] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Work-life balance initiatives</span>
                  </li>
                </ul>
              </div>

              <div className="p-6 bg-white rounded-lg shadow-sm border border-gray-100">
                <h3 className="text-xl font-semibold text-[#0e4322] mb-3">Our Culture</h3>
                <p className="text-gray-700">
                  We foster a culture of innovation, integrity, and inclusion. Our team members are empowered to bring their authentic selves to work and contribute their unique perspectives to solve complex challenges.
                </p>
              </div>
            </motion.div>




          </motion.div>

          {/* Right Column - Form */}
          <motion.div
            className="bg-white rounded-xl sm:rounded-2xl shadow-md sm:shadow-xl overflow-hidden"
            variants={itemVariants}
            initial={{ x: 50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.7 }}
          >
            <div className="p-6 sm:p-8 md:p-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">Application Form</h2>
              <form onSubmit={handleSubmit} className="space-y-6 sm:space-y-8">
                <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 sm:gap-x-6 sm:gap-y-8">
                  {/* Full Name */}
                  <div className="sm:col-span-2">
                    <label htmlFor="name" className="block text-base sm:text-lg font-medium text-gray-900 mb-2">
                      Full Name <span className="text-red-500">*</span>
                    </label>
                    <div className="relative">
                      <input
                        type="text"
                        placeholder="Enter your name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        className="w-full rounded-lg sm:rounded-xl border border-gray-300 px-4 py-3 sm:px-5 sm:py-4 text-gray-900 shadow-sm placeholder-gray-400 focus:ring-2 focus:ring-[#0e4322] focus:border-transparent transition-all"
                      />
                      <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                        <svg className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                        </svg>
                      </div>
                    </div>
                  </div>

                  {/* Email */}
                  <div className="sm:col-span-2">
                    <label htmlFor="email" className="block text-base sm:text-lg font-medium text-gray-900 mb-2">
                      Email <span className="text-red-500">*</span>
                    </label>
                    <div className="relative">
                      <input
                        type="email"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="w-full rounded-lg sm:rounded-xl border border-gray-300 px-4 py-3 sm:px-5 sm:py-4 text-gray-900 shadow-sm placeholder-gray-400 focus:ring-2 focus:ring-[#0e4322] focus:border-transparent transition-all"
                      />
                      <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                        <svg className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>
                      </div>
                    </div>
                  </div>

                  {/* Location */}
                  <div className="sm:col-span-2">
                    <label htmlFor="location" className="block text-base sm:text-lg font-medium text-gray-900 mb-2">
                      Location <span className="text-red-500">*</span>
                    </label>
                    <div className="relative">
                      <input
                        type="text"
                        placeholder="Enter your location"
                        value={location}
                        onChange={(e) => setLocation(e.target.value)}
                        className="w-full rounded-lg sm:rounded-xl border border-gray-300 px-4 py-3 sm:px-5 sm:py-4 text-gray-900 shadow-sm placeholder-gray-400 focus:ring-2 focus:ring-[#0e4322] focus:border-transparent transition-all"
                      />
                      <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                        <svg className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                      </div>
                    </div>
                  </div>

                  {/* Department */}
                  <div className="sm:col-span-2">
                    <label htmlFor="department" className="block text-base sm:text-lg font-medium text-gray-900 mb-2">
                      Department <span className="text-red-500">*</span>
                    </label>
                    <div className="relative">
                      <select
                        value={department}
                        onChange={(e) => setDepartment(e.target.value)}
                        className="w-full rounded-lg sm:rounded-xl border border-gray-300 px-4 py-3 sm:px-5 sm:py-4 text-gray-900 shadow-sm focus:ring-2 focus:ring-[#0e4322] focus:border-transparent appearance-none bg-white bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLWNoZXZyb24tZG93biI+PHBhdGggZD0ibTYgOSA2IDYgNi02Ii8+PC9zdmc+')] bg-no-repeat bg-[center_right_1rem]"
                      >
                        <option value="">Select department</option>
                        <option value="Accounting & Finance">Accounting & Finance</option>
                        <option value="Sales & Marketing">Sales & Marketing</option>
                        <option value="Legal">Legal</option>
                        <option value="Human Resources">Human Resources</option>
                        <option value="Administration & Procurement">Administration & Procurement</option>
                        <option value="IT">IT</option>
                        <option value="Creative">Creative</option>
                        <option value="Subject Matter Specialist">Subject Matter Specialist</option>
                      </select>
                    </div>
                  </div>

                  {/* Resume Upload */}
                  <div className="sm:col-span-2">
                    <label htmlFor="resume" className="block text-base sm:text-lg font-medium text-gray-900 mb-2">
                      Upload Resume <span className="text-red-500">*</span>
                    </label>
                    <div className="flex items-center justify-center w-full">
                      <label className="flex flex-col w-full rounded-lg sm:rounded-xl border-2 border-dashed border-gray-300 hover:border-[#0e4322] hover:bg-gray-50 transition-all cursor-pointer">
                        <div className="flex flex-col items-center justify-center pt-4 pb-5 sm:pt-5 sm:pb-6 px-4">
                          <svg className="w-8 h-8 sm:w-10 sm:h-10 mb-2 sm:mb-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                          </svg>
                          <p className="mb-1 sm:mb-2 text-xs sm:text-sm text-gray-500">
                            <span className="font-semibold">Click to upload</span> or drag and drop
                          </p>
                          <p className="text-xs text-gray-500">PDF, DOC, DOCX (MAX. 5MB)</p>
                        </div>
                        <input
                          id="resume"
                          type="file"
                          accept=".pdf,.doc,.docx"
                          onChange={async (e) => {
                            setResume(await fileTypeVaidation(e, "pdf"));
                            setResumeName(e.target.value);
                          }}
                          className="hidden"
                        />
                      </label>
                    </div>
                    {resumename && (
                      <p className="mt-2 text-sm text-gray-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                        {resumename}
                      </p>
                    )}
                  </div>

                  {/* Cover Letter Upload */}
                  <div className="sm:col-span-2">
                    <label htmlFor="coverletter" className="block text-base sm:text-lg font-medium text-gray-900 mb-2">
                      Upload Cover Letter
                    </label>
                    <div className="flex items-center justify-center w-full">
                      <label className="flex flex-col w-full rounded-lg sm:rounded-xl border-2 border-dashed border-gray-300 hover:border-[#0e4322] hover:bg-gray-50 transition-all cursor-pointer">
                        <div className="flex flex-col items-center justify-center pt-4 pb-5 sm:pt-5 sm:pb-6 px-4">
                          <svg className="w-8 h-8 sm:w-10 sm:h-10 mb-2 sm:mb-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                          </svg>
                          <p className="mb-1 sm:mb-2 text-xs sm:text-sm text-gray-500">
                            <span className="font-semibold">Click to upload</span> or drag and drop
                          </p>
                          <p className="text-xs text-gray-500">PDF, DOC, DOCX (MAX. 5MB)</p>
                        </div>
                        <input
                          id="coverletter"
                          type="file"
                          accept=".pdf,.doc,.docx"
                          onChange={(e) => {
                            setCoverletter(e.target.files[0]);
                            setCoverletterName(e.target.files[0]?.name || "");
                          }}
                          className="hidden"
                        />
                      </label>
                    </div>
                    {coverlettername && (
                      <p className="mt-2 text-sm text-gray-600 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                        {coverlettername}
                      </p>
                    )}
                  </div>

                  {/* Message */}
                  <div className="sm:col-span-2">
                    <label htmlFor="message" className="block text-base sm:text-lg font-medium text-gray-900 mb-2">
                      Message
                    </label>
                    <textarea
                      placeholder="Enter your message"
                      rows={4}
                      value={body}
                      onChange={(e) => setBody(e.target.value)}
                      className="w-full rounded-lg sm:rounded-xl border border-gray-300 px-4 py-3 sm:px-5 sm:py-4 text-gray-900 shadow-sm placeholder-gray-400 focus:ring-2 focus:ring-[#0e4322] focus:border-transparent transition-all"
                    />
                  </div>

                  {/* reCAPTCHA */}
                  <div className="sm:col-span-2 flex justify-center">
                    <div className="scale-90 sm:scale-100 origin-center">
                      <ReCAPTCHA
                        ref={recaptchaRef}
                        sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                        onChange={(token) => setIsCaptchaValid(!!token)}
                      />
                    </div>
                  </div>
                </div>

                {/* Submit Button */}
                <div className="mt-6 sm:mt-8">
                  <motion.button
                    type="submit"
                    disabled={isLoading}
                    className="w-full px-5 py-3 sm:px-6 sm:py-4 bg-gradient-to-r from-[#0e4322] to-[#3a5630] hover:from-[#175f33] hover:to-[#0e4322] text-white text-base sm:text-lg font-bold rounded-lg sm:rounded-xl shadow-md hover:shadow-lg transition-all duration-300 transform hover:scale-[1.01] focus:outline-none focus:ring-2 focus:ring-[#0e4322] focus:ring-offset-2"
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                  >
                    {isLoading ? (
                      <span className="flex items-center justify-center">
                        <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth={4} />
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                        </svg>
                        Processing...
                      </span>
                    ) : (
                      "Submit Application"
                    )}
                  </motion.button>
                </div>
              </form>
            </div>
          </motion.div>
        </motion.div>

        <ToastContainer
          position="top-center"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          className="z-[9999]"
        />
      </div>
    </div>
  );
};

export default CareerEnquiryForm;